"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS = exports.AddToCartState = void 0;
var AddToCartState;
(function (AddToCartState) {
    AddToCartState["DISABLED"] = "DISABLED";
    AddToCartState["ENABLED"] = "ENABLED";
    AddToCartState["OUT_OF_STOCK"] = "OUT_OF_STOCK";
    AddToCartState["PRE_ORDER"] = "PRE_ORDER";
})(AddToCartState = exports.AddToCartState || (exports.AddToCartState = {}));
exports.ADD_FREE_PRODUCTS_PUBLIC_DATA_KEYS = {
    ALLOW_FREE_PRODUCTS: 'ALLOW_FREE_PRODUCTS',
};
//# sourceMappingURL=constants.js.map